import { ComponentBase, component } from "@sygnal/sse-core";

@component('nav_component')
export class NavComponent extends ComponentBase {

  protected async onLoad(): Promise<void> {
    this.injectShineStyles();
  }

  private injectShineStyles(): void {
    const style = document.createElement("style");
    style.textContent = [
      ".nav_cta-button { position: relative; overflow: hidden; }",
      ".nav_cta-button::before { content: ''; position: absolute; top: 0; left: -125%; width: 60%; height: 100%; background: rgba(255,255,255,0.4); transform: skewX(-45deg); transition: left 500ms ease-out; pointer-events: none; }",
      ".nav_cta-button:hover::before { left: 150%; }",
    ].join(" ");
    document.head.appendChild(style);
  }
}
